// extracted by mini-css-extract-plugin
export default {"wrapper":"InputWithIcon_wrapper__KgTRa","padded-input":"InputWithIcon_padded-input__lX4BJ","icon":"InputWithIcon_icon__DX44z"};